import Vuetify from "@/plugins/vuetify";

const questionTypes = {
  getQuestionTypeIcon(id) {
    switch (id) {
      case this.$enums.questionTypes.OPINION_SCALE:
        return "straighten";
      case this.$enums.questionTypes.TEXT_RESPONSE:
        return "chat";
      case this.$enums.questionTypes.MULTIPLE_CHOICE:
        return "done_all";
    }
    return "assignment";
  },
  getQuestionTypeColor(id) {
    switch (id) {
      case this.$enums.questionTypes.OPINION_SCALE:
        return "#F6CC5B";
      case this.$enums.questionTypes.TEXT_RESPONSE:
        return "#ED9671";
      case this.$enums.questionTypes.MULTIPLE_CHOICE:
        return "#66A9DC";
    }
    return Vuetify.framework.theme.themes.light.darkaccent;
  },
  getOpinionScoreColor(i) {
    let score = i - 1;
    if (score >= 8) {
      return Vuetify.framework.theme.themes.light.success;
    } else if (score >= 6) {
      return Vuetify.framework.theme.themes.light.info;
    } else if (score >= 4) {
      return Vuetify.framework.theme.themes.light.lightwarning;
    } else if (score >= 2) {
      return Vuetify.framework.theme.themes.light.warning;
    }
    return Vuetify.framework.theme.themes.light.error;
  }
};

export default { methods: questionTypes };
